import { Flex, Spacing, Text, useModal } from '@billy/design-system'
import { ChangeEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EInvoicingCerfaDownloadButton } from '@features/eInvoicing/elements/EInvoicingCerfaDownloadButton'
import { EInvoicingDisableModal } from '@features/eInvoicing/elements/EInvoicingDisableModal'
import { useAutomaticEInvoiceSettingToggle } from '@features/eInvoicingSettings/hooks/useAutomaticEInvoiceSettingToggle'
import { useUserOrganizationSettings } from '@modules-deprecated/app/organization'

import { ModalId } from '../../../../../../enums/modalId'
import { useSegment } from '../../../../../../hooks'
import { useIsAutoCegidIntegrationEnabled } from '../../../../../../hooks/useIsAutoCegidIntegrationEnabled'
import { EInvoicingAutoForwardToggle } from './elements/EInvoicingAutoForwardToggle'
import { EInvoicingSetupCard } from './elements/EInvoicingSetupCard'

export const EInvoicingSection = () => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { open: openDisableEInvoicingModal } = useModal(ModalId.DisableEInvoicingModal)
  const { organizationSettings } = useUserOrganizationSettings()
  const isAutoForwardEInvoicesEnabled = organizationSettings?.eInvoiceAutomaticCegidIntegration === '1'
  const { isAutoCegidIntegrationEnabled } = useIsAutoCegidIntegrationEnabled()
  const { enable, disable } = useAutomaticEInvoiceSettingToggle()

  const handleCerfaDownloadClick = useCallback(() => {
    track('xxx - e-invoicing - Clicked "Download Proof"')
  }, [track])

  const handleAutoForwardEInvoicesChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      return event.target.checked ? enable() : disable()
    },
    [enable, disable],
  )

  return (
    <Flex flexDirection="column">
      <Flex flexDirection="column" gap={Spacing.S8} justifyContent="center">
        <Text variant="h4" weight="bold">
          {t('receipts.side_panel.e_invoices.title')}
        </Text>

        <Text>{t('receipts.side_panel.e_invoices.description')}</Text>
      </Flex>

      <EInvoicingSetupCard onDeactivateClick={openDisableEInvoicingModal} />

      <EInvoicingCerfaDownloadButton onClick={handleCerfaDownloadClick} />

      {isAutoCegidIntegrationEnabled && (
        <EInvoicingAutoForwardToggle
          checked={isAutoForwardEInvoicesEnabled}
          onChange={handleAutoForwardEInvoicesChange}
        />
      )}

      <EInvoicingDisableModal />
    </Flex>
  )
}
